module.exports = __webpack_public_path__ + "img/circle.66396990.png";